module.exports = __webpack_public_path__ + "img/login-elitesport.2d939a37.svg";